import { Component, Input, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RutaCriticaService } from './services/ruta-critica.service';
import { IGetRutasRequest, IGetRutasResponse } from './interfaces/ruta-critica.interface';
import { RutaFormDialogComponent } from './ruta-form-dialog.component';
import { MessageService } from 'primeng/api';

interface Column {
  field: string;
  header: string;
}

@Component({
  selector: 'app-rutas-dialog',
  templateUrl: './rutas-dialog.component.html',
  providers: [MessageService]
})
export class RutasDialogComponent implements OnInit {
  @Input() proceso: number = 0; // Recibe el proceso actual si es necesario

  displayedColumns: Column[] = [
    { field: 'origen', header: 'Origen' },
    { field: 'destino', header: 'Destino' },
    { field: 'decision', header: 'Decisión' },
    { field: 'correcta', header: 'Auditoría' },
    { field: 'acciones', header: 'Acciones' }
  ];

  dataSource: any[] = [];
  loading: boolean = false;
  globalFilter: string = '';
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  displayDialog: boolean = false;
  selectedRuta: any = null;

  constructor(
    private dialogRef: MatDialogRef<RutasDialogComponent>,
    private rutaCriticaService: RutaCriticaService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private messageService: MessageService
  ) {
    this.proceso = data?.proceso ?? 0;
  }

  ngOnInit(): void {
    this.loadRutas();
  }

  loadRutas() {
    this.loading = true;
    const request: IGetRutasRequest = {
      tope: '999',
      proceso: this.proceso,
      origen: 0,
      destino: 0,
      decision: '',
      correcta: 0
    };
    this.rutaCriticaService.getRutas(request).subscribe({
      next: (res) => {
        if (res.success) {
          this.dataSource = res.data;
          this.totalRecords = res.data.length;
        } else {
          this.dataSource = [];
          this.totalRecords = 0;
        }
      },
      complete: () => this.loading = false
    });
  }

  openCreate() {
    this.selectedRuta = null;
    this.displayDialog = true;
  }

  openUpdate(model: any) {
    this.selectedRuta = model;
    this.displayDialog = true;
  }

  closeDialog() {
    this.dialogRef.close();
  }

  onDialogClosed(event?: {refresh: boolean, numero?: number, success?: boolean}) {
    this.displayDialog = false;
    if (event) {
      if (event.success === true) {
        this.messageService.add({
          severity: 'success',
          summary: 'Éxito',
          detail: 'Ruta creada correctamente'
        });
      } else if (event.success === false) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No se pudo crear la ruta'
        });
      }
      if (event.refresh) {
        this.loadRutas();
      }
    }
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
  }

  onFilter(event: any): void {
    this.globalFilter = event.filteredValue;
  }

  delete(model: any) {
    import('sweetalert2').then(Swal => {
      Swal.default.fire({
        title: '¿Está seguro?',
        text: `¿Está seguro de eliminar la ruta?`,
        icon: 'warning',
        showCancelButton: true,
        iconColor: "#d33",
        confirmButtonColor: "#d33",
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'No',
        heightAuto: false
      }).then((result: any) => {
        if (result.isConfirmed) {
          this.loading = true;
          const request = {
            que: 3,
            tope: '',
            proceso: this.proceso,
            origen: model.origen,
            destino: model.destino,
            decision: '',
            correcta: 0
          };

          this.rutaCriticaService.eliminarRuta(request).subscribe({
            next: (res) => {
              if (res.success) {
                this.messageService.add({
                  severity: 'success',
                  summary: 'Éxito',
                  detail: 'Ruta eliminada correctamente'
                });
                this.loadRutas();
              } else {
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: 'Error al eliminar la ruta'
                });
              }
            },
            error: (error) => {
              console.error('Error al eliminar ruta:', error);
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al eliminar la ruta'
              });
            },
            complete: () => {
              this.loading = false;
            }
          });
        }
      });
    });
  }

  auditar() {
    this.loading = true;
    const request = {
      ruta: this.proceso
    };

    this.rutaCriticaService.auditarRuta(request).subscribe({
      next: (res) => {
        if (res.success) {
          this.messageService.add({
            severity: 'success',
            summary: 'Éxito',
            detail: 'Auditoría realizada correctamente'
          });
          this.loadRutas();
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Error al realizar la auditoría'
          });
        }
      },
      error: (error) => {
        console.error('Error al auditar rutas:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al realizar la auditoría'
        });
      },
      complete: () => {
        this.loading = false;
      }
    });
  }
} 